import "./howItWorks.css";

const HowItWorks = () => {
  return <React.Fragment>
    <div className="howItWorksCont">
      <div className="getSafeTxt">
        Get safe testing with Redcliffe labs
      </div>
       
        <div className="howItWorksCards">
            <div className="howItWorksCard howItWorksCard1">
                <img className="howItWorksCardImg" src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/c7b06f36-6203-4de5-b108-7b0c408142e0.png" alt="" />
                <img className="step1Img" src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/f6bef7d1-37c9-44e7-aa55-904c973b475a.png" alt="" />
                <div className="howItWorksCardDesc">
                    <span className="redTxt">Call and Schedule</span> an appointment with our Redcliffe Expert
                </div>
            </div>
            <div className="howItWorksCard">
                <img className="howItWorksCardImg" src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/891e8496-6271-4b94-a74f-5a1173c3edf3.png" alt="" />
                <img className="step1Img" src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/e87253c6-322c-4b4b-af5d-e422c3d19275.png" alt="" />
                <div className="howItWorksCardDesc">
                    Redcliffe Phlebos will <span className="redTxt">pick-up</span> sample from your home
                </div>
            </div>
            <div className="howItWorksCard">
                <img className="howItWorksCardImg" src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/2b18861c-8812-4e5e-9c24-4e5744102e11.png" alt="" />
                <img className="step1Img" src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/7370a6a7-6068-454c-90a4-8475e8d0d41b.png" alt="" />
                <div className="howItWorksCardDesc">
                    <span className="redTxt"> High-quality</span> lab testing is done in our ISO certified labs
                </div>
            </div>
            <div className="howItWorksCard">
                <img className="howItWorksCardImg" src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/ecbb60ce-9fa9-48d0-8d2d-65c52373abbf.png" alt="" />
                <img className="step1Img" src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/d9293d06-f492-49ed-bc03-12e539303894.png" alt="" />
                <div className="howItWorksCardDesc">
                    We send reports on <span className="redTxt">Mail & WhatsApp</span> after test are completed
                </div>
            </div>
            <div className="howItWorksCard">
                <img className="howItWorksCardImgg" src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/4ba768fd-cc83-4e98-b7d7-5196d597a39e.png" alt="" />
                <img className="step1Img" src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/9ce6291c-c200-4e99-910c-bd8ceff65614.png" alt="" />
                <div className="howItWorksCardDesc">
                    <span className="redTxt">Free doctor consultation</span> with best medical attention you need
                </div>
            </div>
        </div>
     
        
        <div className="howItWorksMobile">

        </div>
    </div>
  </React.Fragment>;
};

export default HowItWorks;
